import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "links" }

import TopNav from '@/components/TopNav.vue';
import ConfirmPopup from 'primevue/confirmpopup';
import Toast from 'primevue/toast';

export default {
  __name: 'AppLayout',
  setup(__props) {


return (_ctx, _cache) => {
  const _component_router_view = _resolveComponent("router-view")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TopNav),
    _createVNode(_component_router_view),
    _createElementVNode("footer", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, { to: "/o-nas" }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("O nas")
          ])),
          _: 1,
          __: [0]
        }),
        _createVNode(_component_router_link, { to: "/kontakt" }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Kontakt")
          ])),
          _: 1,
          __: [1]
        }),
        _createVNode(_component_router_link, { to: "/regulamin" }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("Regulamin")
          ])),
          _: 1,
          __: [2]
        }),
        _createVNode(_component_router_link, { to: "/polityka-prywatnosci" }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("Polityka Prywatności")
          ])),
          _: 1,
          __: [3]
        })
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "copy" }, " © 2025 rezerwujwizyty.pl – Wszelkie prawa zastrzeżone ", -1))
    ]),
    _createVNode(_unref(Toast)),
    _createVNode(_unref(ConfirmPopup))
  ], 64))
}
}

}